// © Thibault Sabathier, 2026. Tous droits réservés.
// frontend/src/components/BuildVersion.js
//
// Version du build chargé, discrète, pour diagnostiquer une PWA qui garderait un ancien build.
// Aucun texte traduisible : « commit · date UTC ».
import React from 'react'
import { formatBuildLabel, getBuildInfo } from '../utils/buildInfo'

const BuildVersion = ({ className = '' }) => {
  const info = getBuildInfo()
  return (
    <span
      className={`build-version text-medium-emphasis ${className}`.trim()}
      style={{ fontSize: '0.7rem', userSelect: 'all' }}
      data-build-version={info.version}
    >
      {formatBuildLabel(info)}
    </span>
  )
}

export default React.memo(BuildVersion)
